export interface ZebraPrinterDevice {
  connection?: string;
  send: (data: string, onSuccess: () => void, onError: (err: string) => void) => void;
  sendThenRead: (
    data: string,
    onResponse: (response: string) => void,
    onError?: (err: string) => void
  ) => void;
}

export interface BrowserPrintStatic {
  getDefaultDevice: (
    type: string,
    onSuccess: (device: ZebraPrinterDevice | null) => void,
    onError: (errorResponse: unknown) => void
  ) => void;
  getLocalDevices: (
    onSuccess: (devices: ZebraPrinterDevice[]) => void,
    onError?: (err: string) => void,
    type?: string
  ) => void;
}

export type ZebraPrinterConnectionStatus = "idle" | "connecting" | "connected" | "error";

export const ZEBRA_BROWSER_PRINT_UNAVAILABLE_MESSAGE =
  "An error occured while attempting to connect to your Zebra Printer. You may not have Zebra Browser Print installed, or it may not be running. Install Zebra Browser Print, or start the Zebra Browser Print Service, and try again.";
